import * as React from 'react';
import { PageProps } from "src/models/common/ComponentProps";
import bindAllOfThis from "src/utils/BindThisHelper";
import { message } from 'antd';
import PhaserSpacePetsGame from 'src/games/SpacePets/Main';

interface SpacePetsGameProps extends PageProps<{}> {
    onComplete?: () => void;
}

class SpacePetsGame extends React.Component<SpacePetsGameProps> {
    constructor(props: SpacePetsGameProps) {
        super(props);
        bindAllOfThis(this, SpacePetsGame.prototype);
    }

    completeGame() {
        return message.success("You finished the game!");
    }

    render() {
        return <div>
            <PhaserSpacePetsGame onComplete={this.completeGame}/>
        </div>;
    }
}

export default SpacePetsGame;



// WEBPACK FOOTER //
// ./src/pages/game/SpacePetsGame.tsx